import styled, { css } from 'styled-components/macro';
import { Popover } from '../popover';

export const StyledContent = styled(Popover.Content)`
  ${({ theme }) => css`
    z-index: 1000;
    box-sizing: border-box;
    width: 300px;
    min-width: 300px;
    background-color: ${theme.semantic.bg.inverse};
    color: ${theme.semantic.text.onInverse};
    border-color: ${theme.semantic.border.inverse};
    white-space: normal;

    .popover-arrow {
      fill: ${theme.semantic.bg.inverse};
      stroke: ${theme.semantic.border.inverse};
    }
  `}
`;

export const Description = styled.div`
  padding-left: 24px;
`;
